import React from 'react'
import PropTypes from 'prop-types'
import { EmbedInlineStoryQuery } from '@components/embed-inline-story'

function RenderInlineEmbeddedEntry(props) {
  return (
    <EmbedInlineStoryQuery {...props} />
  )
}

RenderInlineEmbeddedEntry.propTypes = {
  id: PropTypes.string,
  linkType: PropTypes.string,
  type: PropTypes.string,
}

export default RenderInlineEmbeddedEntry
